import React from 'react';
import AddCarType from './AddCarType';
import AddCarPlateInformation from './AddCarPlateInformation';
import AddCarPlateDetail from './AddCarPlateDetail';
import AddNewCarOrderSummary from './AddNewCarOrderSummary';
import AddNewCarApproval from './AddNewCarApproval';
import { useSelector } from 'react-redux';
import '@src/styles/addNewCar/addNewCarContainer.scss';
const AddNewCarContainer = () => {
  const { activeStep } = useSelector((state) => state.addCarType);
  return (
    <div className="add-car-content" data-testid="add-new-car-container-component">
      {activeStep === 0 && <AddCarType data-testid="add-car-type-component" />}
      {activeStep === 1 && (
        <AddCarPlateInformation data-testid="add-car-plate-information-component" />
      )}
      {activeStep === 2 && <AddCarPlateDetail data-testid="add-car-plate-detail-component" />}
      {activeStep === 3 && <AddNewCarOrderSummary data-testid="add-car-order-summary-component" />}
      {activeStep === 4 && <AddNewCarApproval data-testid="add-car-approval-component" />}
    </div>
  );
};

export default AddNewCarContainer;
